import { HiChevronDoubleRight } from "react-icons/hi"; 
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxToolbar from '../../cx/CxToolbar';
import CxSnackbar from '../../cx/CxSnackbar';
import CxStatic from '../../cx/CxStatic';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
//import * as FxDat from '../../fx/FxDat';
import { StoreMarketing, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { useNav } from '../../hx/useNav';
import CxInputTemplate from '../../cx/CxInputTemplate';
import CxIconButtonNew from '../../cx/CxIconButtonNew';


const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: 'var(--ibs_container_gap)',
    margin: 'var(--ibs_container_margin)',
  },
  button_frame: {
    margin: '20px 0 0 0',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
  },
}));

const MxMarketingOptionW = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const classes = useStyles(props);

  const rf_credits = React.useRef(null);
  const rf_txContent = React.useRef(null);
  
  // eslint-disable-next-line
  const [templateName, setTemplateName] = React.useState('');
  
  const r_snack_error = React.useRef(null);
  
  // eslint-disable-next-line
  const [storeMarketing, setStoreMarketing] = useSessionStorage('StoreMarketing', StoreMarketing);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    rf_txContent.current.setVal(storeMarketing.txWhatsapp);
  }

  const doTemplateSelected = (name, cont) => {
    FxLog.infox('MxMarketingOptionW.doTemplateSelected', '...', name +' - '+ cont);
    setTemplateName(name);
    rf_txContent.current.setVal(cont.substring(0, 160));
  }

  const getPlaceholders = () => {
    let ph = [];
    if (isApp('vett') || isApp('spaw')) {
      ph.push({ id: "[name]", type: trans('field.name') });
      ph.push({ id: "[first_name]", type: trans('field.name_first') });
      ph.push({ id: "[last_name]", type: trans('field.name_last') });
      ph.push({ id: "[contact]", type: trans('field.contact') });
      ph.push({ id: "[animal]", type: trans('field.patient') });
      if (storeMarketing.arPssFq) {
        ph.push({ id: "[ps]", type: trans('field.vacc') + '-' + trans('field.name') });
        ph.push({ id: "[alias]", type: trans('field.vacc') + '-' + trans('field.alias') });
        ph.push({ id: "[next]", type: trans('field.vacc') + '-' + trans('field.next') });
      }
      return ph;
    }
    if (isApp('opti')) {
      ph.push({ id: "[name]", type: trans('field.name') });
      ph.push({ id: "[first_name]", type: trans('field.name_first') });
      ph.push({ id: "[last_name]", type: trans('field.name_last') });
      ph.push({ id: "[contact]", type: trans('field.contact') });
      if (storeMarketing.arPssFq) {
        ph.push({ id: "[ps]", type: trans('field.repl') + '-' + trans('field.name') });
        ph.push({ id: "[alias]", type: trans('field.repl') + '-' + trans('field.alias') });
        ph.push({ id: "[next]", type: trans('field.repl') + '-' + trans('field.next') });
      }
      return ph;
    }
    if (isApp('invo')) {
      ph.push({ id: "[name]", type: trans('field.name') });
      ph.push({ id: "[first_name]", type: trans('field.name_first') });
      ph.push({ id: "[last_name]", type: trans('field.name_last') });
      ph.push({ id: "[contact]", type: trans('field.contact') });
      return ph;
    }
  }

  const goNext = async () => {
    if (rf_txContent.current.isEmpty()) {
      r_snack_error.current.setValAndOpen(trans('msg.missing_x', 'field.message'));
      return;
    }
    storeMarketing.txWhatsapp = rf_txContent.current.getVal();
    setStoreMarketing(storeMarketing);

    navTo("marketing-list");
  }

  return (
    <div>
      <CxToolbar 
        moduleName={`${trans('field.marketing')}: ${trans('field.options')}: Whatsapp`} 
        background={storeMarketing.marketingType==='E' ? 'var(--ibs_color_red_light)' : 'var(--ibs_color_blue_light)'}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<HiChevronDoubleRight fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={goNext} tooltip={trans('field.next')} />
          </div>
        }
      />

      <div className={classes.container}>

      <CxStatic xref={rf_credits} border='none' fontsize='14px' />
      <CxInputTemplate xref={rf_txContent} label={trans('field.content')} minRows={2} maxLength={160} required
          tpl_table={"n_sms_tpl"} tpl_col_id={"inSmsTpl"} tpl_col_tx={"txName"} tpl_filter={""} tpl_extra_filter_1={""} tpl_content_field={"txContent"}
          hasTplButtonAdd
          onTemplateSelected={doTemplateSelected}
          placeholders={getPlaceholders}
          speech
        />


      </div>

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxMarketingOptionW;
